import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "./Informacion.css";
import { InformacionItem } from "../../json/informacionItem";

const Informacion = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="container informacion-container">
      <div className="row">
        <div className="col-12">
          <div className="informacion_title">
            <h1>Información Relevante</h1>
          </div>
        </div>
      </div>
      <div className="row">
        
        {InformacionItem.map((item, index) => (
          //<div className="col-md-4 col-sm-6 col-12" >      
          <div className="col-md-12 col-sm-12 col-12" >      
            <hr class="hr-gob"></hr>
            <h2>{item.informacion_grupo}</h2>
              <div className="links-informacion">
                <ul>
                  {item.informacion_array.map((itemint, i) => (
                    <div>
                      <li>      
                        <Link target="_blank" to={itemint.informacion_item_url}>
                          {itemint.informacion_item_nombre}                      
                        </Link>     
                      </li>                      
                    </div>       
                  ))}
                </ul>
              </div>
            
          </div>
          
        ))}
      </div>
    </div>
    
  );
};

export default Informacion;
